module.exports = __webpack_public_path__ + "images/ds-fw2024-pricing-mobile.webp";